<dw-ui-dialog-box
  [title]="'Doc::CustomerSalesPurchase:CreateProductionFolder'"
  [saveDisabled]="form.invalid || !linesCanSave()"
  [saveBusy]="isSaving()"
  (saveFn)="save()"
>
  <div class="p-2">
    <form [formGroup]="form" class="row g-3">
      <div class="col-12 col-md-6">
        <label for="productionSiteId" class="form-label text-primary" dwInputRequired>
          {{ 'Doc::ProductionCompanySite' | abpLocalization }}
        </label>
        <ng-select
          class="form-control"
          id="productionSiteId"
          bindLabel="address.name"
          bindValue="id"
          formControlName="productionSiteId"
          [items]="productionSites$ | async"
        >
        </ng-select>
      </div>

      <div class="col-12 col-md-6">
        <label for="workOrderDayBookId" class="form-label text-primary" dwInputRequired>
          {{ 'Doc::Menu:Settings:WorkOrderDayBooks' | abpLocalization }}
        </label>
        <ng-select
          class="form-control"
          id="workOrderDayBookId"
          bindLabel="name.current"
          bindValue="id"
          formControlName="workOrderDayBookId"
          [items]="workOrderDayBooks$ | async"
        >
        </ng-select>
      </div>

      <div class="col-12 col-md-6">
        <label for="responsibleId" class="form-label text-primary" dwInputRequired>
          {{ 'Doc::ResponsibleProduction' | abpLocalization }}
        </label>
        <ng-select
          class="form-control"
          id="responsibleId"
          bindLabel="code"
          bindValue="id"
          formControlName="responsibleId"
          [dwApiSelect]="workerSelect"
        >
          <ng-template ng-label-tmp let-item="item">
            @if (item != null) {
              {{ item.lastName }} {{ item.firstName }}
            }
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.lastName }} {{ item.firstName }}
          </ng-template>
        </ng-select>
      </div>

      <div class="col-12 col-md-6">
        <label for="manufacturerId" class="form-label text-primary" dwInputRequired>
          {{ '::Manufacturer' | abpLocalization }}
        </label>
        <ng-select
          class="form-control"
          id="manufacturerId"
          bindLabel="name"
          bindValue="id"
          formControlName="manufacturerId"
          [dwApiSelect]="manufacturerSelect"
        >
        </ng-select>
      </div>

      <div class="col-12 col-md-6">
        <label for="preferredProductionDate" class="form-label text-primary" dwInputRequired>
          {{ 'Doc::EndProdDate' | abpLocalization }}
        </label>
        <dw-core-date-picker
          formControlName="preferredProductionDate"
          [minDate]="minPickerDate"
        ></dw-core-date-picker>
      </div>

      <!-- Wired to the create call but always "No" and not modifiable for now. -->
      <div class="col-12">
        <div class="form-check form-switch">
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            id="splitByPiece"
            formControlName="splitByPiece"
          />
          <label for="splitByPiece" class="form-check-label text-primary">
            {{ 'Doc::CustomerSalesPurchase:SplitProductionByPiece' | abpLocalization }}
          </label>
        </div>
      </div>
    </form>

    <div class="mt-2">
      <document-production-doc-creation-grid
        [lines]="lines"
        (canSaveChange)="linesCanSave.set($event)"
      ></document-production-doc-creation-grid>
    </div>
  </div>
</dw-ui-dialog-box>
